export default "__VITE_ASSET__wEP3IV12__"